export * from './brandiq-basic.page';
export * from './tabs';
